// ── PALETTE (copia locale — identica a App.js) ────────────────────────────────
const P = {
  bg:"#080B14", card:"#0D1020", border:"#1D2238",
  gold:"#E9622A", goldGlow:"rgba(233,98,42,0.12)", goldBorder:"rgba(233,98,42,0.30)",
  text:"#EBE8F5", muted:"#8A8EAE", secondary:"#B4B7D0",
  green:"#5BB87A", yellow:"#E9622A", red:"#C46B6B", blue:"#5A82B8", purple:"#a78bfa",
  sidebar:"#060810", card2:"#111525", card3:"#161B2E",
  borderSubtle:"#141829", borderStrong:"#2A3055"
};

const InfoTooltip = ({ lines, setTooltip }) => {
  const open = (e) => {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    const estH = lines.length * 24 + 32;
    let x = rect.right + 8;
    let y = rect.top;
    if (x + 260 > window.innerWidth)  x = rect.left - 268;
    if (y + estH > window.innerHeight) y = window.innerHeight - estH - 8;
    setTooltip({ x, y, lines });
  };
  return (
    <span
      data-info-tip="1"
      onMouseEnter={open}
      onMouseLeave={() => setTooltip(null)}
      onTouchStart={(e) => { e.preventDefault(); open(e); }}
      style={{
        display:"inline-flex", alignItems:"center", justifyContent:"center",
        padding:10, margin:"-10px -10px -10px -5px",
        cursor:"pointer", flexShrink:0, userSelect:"none",
        verticalAlign:"middle",
      }}
    >
      <span style={{
        display:"inline-flex", alignItems:"center", justifyContent:"center",
        width:16, height:16, borderRadius:"50%",
        background:"rgba(71,75,104,.25)", color:"#B4B7D0",
        fontSize:11, fontWeight:700,
        fontFamily:"'IBM Plex Mono',monospace", lineHeight:1,
        pointerEvents:"none",
      }}>ℹ</span>
    </span>
  );
};

const mc = (m, colors) => colors[m] || P.gold;

const Avatar = ({nome, color, size=30}) => (
  <div style={{width:size,height:size,borderRadius:"50%",background:`${color}20`,
    border:`1px solid ${color}44`,display:"flex",alignItems:"center",
    justifyContent:"center",fontSize:size*0.4,color,fontWeight:700,flexShrink:0}}>
    {nome.charAt(0)}
  </div>
);

export default function Stipendi({
  allievi, mkeys, maestriColors, stipendiPagati,
  isMobile, dbReady,
  goToMaestro, goToAllievo, saveHistory, setStipendi, saveStipendioToDB,
  stipendioMaestro, meseAllievi, getAllievoCorsi, isTitolare,
  setTooltip, getRettaImportoMese, getRettaPagata
}) {
  const matchM = (key, name) => {
    const k = (key || '').trim().toUpperCase();
    const n = (name || '').trim().toUpperCase();
    return n === k || n.startsWith(k + ' ') || k.startsWith(n + ' ');
  };

  const stipData = mkeys.map(m => {
    // Tutti gli allievi che hanno almeno un corso con questo maestro
    const tutti = allievi.filter(a =>
      getAllievoCorsi(a).some(c => matchM(m, c.maestro))
    );
    const paganti = tutti.filter(a => getRettaPagata(a.id, meseAllievi));
    const nonPag  = tutti.filter(a => !getRettaPagata(a.id, meseAllievi));

    // Stipendio calcolato con la logica centralizzata (include MDI + singolo retta×60%)
    const stipendio = Math.round(stipendioMaestro(m, meseAllievi) * 100) / 100;
    // Lordo = somma delle rette NETTE (al netto dello sconto) dei soli paganti
    // Lo sconto riduce quanto incassiamo, ma NON riduce lo stipendio del maestro
    const lordo = paganti.reduce((s, a) => {
      const tuttiCorsi = getAllievoCorsi(a);
      const rettaM = tuttiCorsi
        .filter(c => matchM(m, c.maestro))
        .reduce((sr, c) => sr + (c.retta || 0), 0);
      const totalRetta = tuttiCorsi.reduce((sr, c) => sr + (c.retta || 0), 0);
      const ratio = totalRetta > 0 ? rettaM / totalRetta : 1;
      const importoMese = getRettaImportoMese(a.id, meseAllievi);
      const nettoMese = Math.max(0, importoMese - (a.sconto || 0));
      return s + Math.round(nettoMese * ratio * 100) / 100;
    }, 0);
    const netto   = lordo - stipendio;
    const pagato  = !!(stipendiPagati[meseAllievi]?.[m]);

    return { m, tutti, paganti, nonPag, lordo, stipendio, netto, pagato };
  }).filter(d => d.tutti.length > 0);

  const stipDataMaestri = stipData.filter(d => !isTitolare(d.m));
  const totStipDovuto = stipDataMaestri.filter(d=>!d.pagato).reduce((s,d)=>s+d.stipendio,0);
  const totStipPagato = stipDataMaestri.filter(d=>d.pagato).reduce((s,d)=>s+d.stipendio,0);
  const totLordo      = stipData.reduce((s,d)=>s+d.lordo,0);

  return (
    <div style={{animation:"fi .35s ease"}}>
      <div style={{marginBottom:26}}>
        <div style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:11,letterSpacing:3,color:P.muted,marginBottom:7,fontWeight:400,textTransform:"uppercase"}}>CONTABILITÀ</div>
        <div style={{display:"flex",alignItems:"center"}}>
          <h1 style={{fontFamily:"'Syne',sans-serif",fontSize:isMobile?22:32,fontWeight:800,letterSpacing:-0.5}}>Stipendi Maestri</h1>
        </div>
      </div>

      {/* Riepilogo totali */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12,marginBottom:24}}>
        {[
          {l:"Lordo incassato", v:`€${totLordo}`, c:P.gold,
           tip:[
             {label:"Importo effettivamente incassato"},
             {label:"dagli allievi (netto sconti)"},
             {label:"Totale lordo", value:`€${totLordo}`, highlight:true, sep:true},
           ]},
          {l:"Da pagare", v:`€${totStipDovuto}`, c:P.red,
           tip: stipDataMaestri.filter(d=>!d.pagato).length > 0
             ? [
                 ...stipDataMaestri.filter(d=>!d.pagato).map(d=>({label:d.m.split(' ')[0], value:`€${d.stipendio}`})),
                 {label:"Totale da pagare", value:`€${totStipDovuto}`, highlight:true, sep:true},
               ]
             : [{label:"Nessuno stipendio da pagare"}]
          },
          {l:"Già pagato", v:`€${totStipPagato}`, c:P.green,
           tip: stipDataMaestri.filter(d=>d.pagato).length > 0
             ? [
                 ...stipDataMaestri.filter(d=>d.pagato).map(d=>({label:d.m.split(' ')[0], value:`€${d.stipendio}`})),
                 {label:"Totale pagato", value:`€${totStipPagato}`, highlight:true, sep:true},
               ]
             : [{label:"Nessuno stipendio ancora pagato"}]
          },
        ].map(s=>(
          <div key={s.l} style={{background:P.card,border:`1px solid ${P.border}`,borderRadius:12,
            padding:"14px 18px",borderLeft:`3px solid ${s.c}`}}>
            <div style={{fontSize:11,color:P.muted,letterSpacing:1,marginBottom:4}}>{s.l.toUpperCase()}</div>
            <div style={{display:"flex",alignItems:"center",gap:4}}>
              <div style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:22,fontWeight:500,color:s.c}}>{s.v}</div>
              <InfoTooltip lines={s.tip} setTooltip={setTooltip}/>
            </div>
          </div>
        ))}
      </div>

      {/* Schede maestri */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(320px,1fr))",gap:16}}>
        {stipData.map(d=>{
          const c   = mc(d.m, maestriColors);
          const ps  = d.pagato
            ? {bg:"rgba(52,120,80,0.15)",color:P.green, label:"Pagato", border:"rgba(52,120,80,0.35)"}
            : {bg:"rgba(180,60,60,0.15)",color:P.red,   label:"Da pagare", border:"rgba(180,60,60,0.35)"};

          return (
            <div key={d.m} style={{background:P.card,border:`1px solid ${P.border}`,
              borderRadius:14,padding:22,borderTop:`3px solid ${c}`}}>

              {/* Header */}
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
                <div style={{display:"flex",alignItems:"center",gap:11,cursor:"pointer"}}
                  onClick={()=>goToMaestro(d.m)}
                  title="Clicca per vedere le presenze di questo maestro">
                  <Avatar nome={d.m} color={c} size={40}/>
                  <div>
                    <div style={{fontWeight:600,fontSize:16,color:c,transition:"opacity .15s"}}
                      onMouseEnter={e=>e.currentTarget.style.opacity=.7}
                      onMouseLeave={e=>e.currentTarget.style.opacity=1}>{d.m}</div>
                    <div style={{fontSize:13,color:P.muted,marginTop:1}}>
                      {d.paganti.length}/{d.tutti.length} allievi · <span style={{color:c}}>♫ vedi presenze</span>
                    </div>
                  </div>
                </div>
                <span onClick={()=>{saveHistory({tipo:'stipendio',m:d.m,mese:meseAllievi,prima:!!stipendiPagati[meseAllievi]?.[d.m]});const nv=!(stipendiPagati[meseAllievi]?.[d.m]);setStipendi(p=>({...p,[meseAllievi]:{...(p[meseAllievi]||{}),[d.m]:nv}}));if(dbReady)saveStipendioToDB(d.m,nv,meseAllievi);}}
                  style={{display:"inline-flex",alignItems:"center",gap:5,fontFamily:"'IBM Plex Mono',monospace",
                    fontSize:12,padding:"4px 11px",borderRadius:99,fontWeight:400,letterSpacing:0.3,
                    cursor:"pointer",background:ps.bg,color:ps.color,
                    border:`1px solid ${ps.border}`,userSelect:"none",transition:"all .2s"}}>
                  <span style={{width:5,height:5,borderRadius:"50%",background:"currentColor",display:"inline-block"}}/>
                  {ps.label}
                </span>
              </div>

              {/* Numeri */}
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,marginBottom:16}}>
                <div style={{background:P.bg,borderRadius:8,padding:"10px 12px"}}>
                  <div style={{fontSize:11,color:P.muted,letterSpacing:1,marginBottom:3}}>LORDO</div>
                  <div style={{display:"flex",alignItems:"center",gap:4}}>
                    <div style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:18,fontWeight:500,color:P.gold}}>€{d.lordo}</div>
                    <InfoTooltip setTooltip={setTooltip} lines={[
                      {label:"Rette nette incassate"},
                      {label:"dagli allievi paganti"},
                      {label:"Lordo", value:`€${d.lordo}`, highlight:true, sep:true},
                    ]}/>
                  </div>
                </div>
                <div style={{background:P.bg,borderRadius:8,padding:"10px 12px"}}>
                  <div style={{fontSize:11,color:P.muted,letterSpacing:1,marginBottom:3}}>STIPENDIO</div>
                  <div style={{display:"flex",alignItems:"center",gap:4}}>
                    <div style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:18,fontWeight:500,color:P.red}}>€{d.stipendio}</div>
                    <InfoTooltip setTooltip={setTooltip} lines={[
                      {label: isTitolare(d.m) ? "Titolare: 100% retta lorda" : "60% della retta lorda"},
                      {label:"Indipendente dagli sconti"},
                      {label:"Stipendio", value:`€${d.stipendio}`, highlight:true, sep:true},
                    ]}/>
                  </div>
                </div>
                <div style={{background:P.card2,borderRadius:8,padding:"10px 12px",
                  border:`1px solid ${P.borderSubtle}`}}>
                  <div style={{fontSize:11,color:P.muted,letterSpacing:1,marginBottom:3}}>NETTO</div>
                  <div style={{display:"flex",alignItems:"center",gap:4}}>
                    <div style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:18,fontWeight:500,color:P.green}}>€{d.netto}</div>
                    <InfoTooltip setTooltip={setTooltip} lines={[
                      {label:"Lordo incassato", value:`€${d.lordo}`},
                      {label:"− Stipendio maestro", value:`-€${d.stipendio}`},
                      {label:"Netto accademia", value:`€${d.netto}`, highlight:true, sep:true},
                    ]}/>
                  </div>
                </div>
              </div>

              {/* Lista allievi */}
              <div style={{maxHeight:220,overflowY:"auto"}}>
                {d.paganti.map(a=>{
                  const rettaM = getAllievoCorsi(a)
                    .filter(cc => matchM(d.m, cc.maestro))
                    .reduce((sr, cc) => sr + (cc.retta||0), 0);
                  // Quanto incassato realmente (al netto dello sconto, proporzionale al corso)
                  const totalRetta = getAllievoCorsi(a).reduce((sr, cc) => sr + (cc.retta||0), 0);
                  const ratio = totalRetta > 0 ? rettaM / totalRetta : 0;
                  const importoMese = getRettaImportoMese(a.id, meseAllievi);
                  const incassatoM = Math.round(Math.max(0, importoMese - (a.sconto||0)) * ratio * 100) / 100;
                  const perc = isTitolare(d.m) ? 1.0 : 0.60;
                  // Il maestro viene pagato sempre sul lordo (rettaM), indipendentemente dallo sconto
                  const qm = Math.round(rettaM * perc * 100) / 100;
                  return (
                    <div key={a.id} style={{display:"flex",justifyContent:"space-between",
                      alignItems:"center",padding:"6px 0",borderBottom:`1px solid ${P.border}33`}}>
                      <div style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer"}}
                        onClick={()=>goToAllievo(a.nome)}>
                        <span style={{color:P.green,fontSize:14,fontWeight:700}}>✓</span>
                        <span style={{fontSize:14,color:P.text,transition:"color .15s"}}
                          onMouseEnter={e=>e.currentTarget.style.color=P.green}
                          onMouseLeave={e=>e.currentTarget.style.color=P.text}>{a.nome}</span>
                      </div>
                      <div style={{display:"flex",alignItems:"center",gap:8}}>
                        <span style={{fontSize:14,color:P.muted}}>€{incassatoM}</span>
                        <span style={{fontFamily:"'Syne',sans-serif",fontSize:15,color:c,fontWeight:700}}>→ €{qm}</span>
                      </div>
                    </div>
                  );
                })}
                {d.nonPag.map(a=>{
                  const rettaM = getAllievoCorsi(a)
                    .filter(cc => matchM(d.m, cc.maestro))
                    .reduce((sr, cc) => sr + (cc.retta||0), 0);
                  return (
                    <div key={a.id} style={{display:"flex",justifyContent:"space-between",
                      alignItems:"center",padding:"6px 0",borderBottom:`1px solid ${P.border}22`}}>
                      <div style={{display:"flex",alignItems:"center",gap:6}}>
                        <span style={{color:P.muted,fontSize:14}}>○</span>
                        <span style={{fontSize:14,color:P.muted}}>{a.nome}</span>
                      </div>
                      <span style={{fontSize:13,color:P.muted}}>€{rettaM} · non ancora</span>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
